import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Cookies from 'js-cookie';
import { LeftNav } from '../components/nav';
import { useGlobal } from '../state';

export default function Handle() {
  const navigate = useNavigate();
  const { fox, apiKey, isDev } = useGlobal();

  useEffect(() => {
    if (!fox) {
      return;
    }
    if (!apiKey) {
      return;
    }

    let handleAgent;
    try {
      handleAgent = JSON.parse(Cookies.get('handleAgent') || '');
    } catch {
      // ignore
    } finally {
      Cookies.set('handleAgent', '');
    }

    const handleUrl = Cookies.get('handleUrl');
    Cookies.set('handleUrl', '');

    if (handleAgent?.prompt) {
      fox
        .agent({
          prompt: handleAgent.prompt,
          ...handleAgent.extraParams,
          detach: true,
        })
        .then((out) => {
          console.log('Run gave out:', out);
          navigate(`/agents/${out.jobId}`);
        });

      return;
    }

    if (handleUrl) {
      window.location.href = handleUrl;
      return;
    }

    navigate(`/dashboard`);
  }, [fox, apiKey]);

  return (
    <LeftNav>
      <p>One moment...</p>
    </LeftNav>
  );
}
